import React, { Component } from 'react';
import './Label.css';
import utils from '../../utils/utils';

export default class Label extends Component {
	componentDidMount = () => {
		this.autoSize(this.props.children);
	};
	componentWillReceiveProps(nextProps, nextContext) {
		this.autoSize(nextProps.children);
	}

	autoSize = (value) => {
		if (!this.props.autosize) return;
		if (!this.element) return;
		let width = utils.getTextWidth('17px', value);
		this.element.style.width = width + 46 + 'px';
	};

	_getClasses = () => {
		return (this.props.className || '') + ' g-label ' + this._propsToClass();
	};

	_propsToClass = () => {
		let props = [
			'isHeader',
			'onClick',
			'tabIndex',
			'center',
			'justify', //text-align
			'small',
			'medium-small',
			'medium',
			'medium-plus',
			'large',
			'larger',
			'very-large',
			'largest', //size
			'italic',
			'bold',
			'pastel',
			'capitalize', //style
			'black-light',
			'black',
			'light',
			'gray-light',
			'gray-medium',
			'green',
			'red',
			'white',
			'blue',
			'orange',
			'gray-dark'
		]; //color
		let classes = [];
		for (let i in props) {
			if (this.props[props[i]]) {
				classes.push(props[i]);
			}
		}
		return classes.join(' ');
	};

	_getProp = (prop) => {
		if (this.props[prop]) return ' ' + prop + ' ';
		return '';
	};



	render() {
    const otherProps = {}
    if('tabIndex' in this.props) {
      otherProps.tabIndex = this.props.tabIndex;
    }
    if('onClick' in this.props) {
      otherProps.tabIndex = "0"
    }
	if('isHeader' in this.props){
		return (
			<h1
			{...otherProps}
				ref={(ref) => (this.element = ref)}
				style={this.props.style}
				onClick={this.props.onClick}
				className={this._getClasses()}
			>
				{this.props.children}
			</h1>
		);
	}
	else
		return (
			<div
        {...otherProps}
				ref={(ref) => (this.element = ref)}
				style={this.props.style}
				onClick={this.props.onClick}
				className={this._getClasses()}
			>
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/label/Label.jsx